; (function () {
  'use strict'

  const STORAGE_KEY = 'bfw:wishlist'
  const CREATED_KEY = 'bfw:wishlist:created'
  const API_CACHE_TTL = 30000
  // 后端“尚未创建清单”的业务码（draw 与 detail 都会返回），属于空态而不是请求失败。
  const UNCREATED_CODES = ['10004950']

  function token() {
    const name = window.__MC__CONFIG__?.cookieName || 'momcozy-token'
    const prefix = encodeURIComponent(name) + '='
    const part = (document.cookie || '').split(';').map((value) => value.trim()).find((value) => value.startsWith(prefix))
    return part ? decodeURIComponent(part.slice(prefix.length)) : ''
  }

  function normalize(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {}
    const result = Object.create(null)
    Object.keys(raw).forEach((pid) => {
      if (!/^\d+$/.test(pid) || !Array.isArray(raw[pid])) return
      const entries = raw[pid].filter((entry) => entry && /^\d+$/.test(String(entry.uid)) && Number(entry.qty) > 0)
        .map((entry) => ({
          uid: String(entry.uid),
          qty: Math.min(999, Math.max(1, Math.floor(Number(entry.qty)) || 1)),
          handle: typeof entry.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(entry.handle) ? entry.handle : '',
        }))
      if (entries.length) result[pid] = entries
    })
    return result
  }

  function localState() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
      if (raw?.items && typeof raw.items === 'object' && !Array.isArray(raw.items)) {
        return { items: normalize(raw.items), created: !!raw.created }
      }
      return { items: normalize(raw), created: localStorage.getItem(CREATED_KEY) === '1' }
    } catch (error) { return { items: {}, created: false } }
  }

  function parseJson(value) {
    if (typeof value !== 'string') return value
    try { return JSON.parse(value) } catch (error) { return null }
  }

  function wishlistOf(remote) {
    if (!remote || typeof remote !== 'object') return null
    return remote.wishlist && typeof remote.wishlist === 'object' ? remote.wishlist : remote
  }

  function remoteItems(remote) {
    const source = wishlistOf(remote)
    if (!source) return {}
    let raw = parseJson(source.itemsJson)
    if (raw && !Array.isArray(raw)) raw = raw.items
    if (!Array.isArray(raw)) return {}
    const result = Object.create(null)
    let count = 0
    raw.forEach((entry) => {
      if (!entry) return
      const pid = String(entry.spuId || entry.spu_id || '')
      const uid = String(entry.skuId || entry.sku_id || '')
      if (!/^\d+$/.test(pid) || !/^\d+$/.test(uid) || count >= 4 && !result[pid]) return
      if (!result[pid]) {
        result[pid] = []
        count++
      }
      const handle = entry.handle || entry.spuHandle || ''
      result[pid].push({ uid, qty: entry.quantity || entry.qty || 1, handle: typeof handle === 'string' ? handle : '' })
    })
    return normalize(result)
  }

  function remoteHandles(remote) {
    const map = Object.create(null)
    const source = wishlistOf(remote)
    if (!source) return map
    const raw = parseJson(source.spuHandlesJson)
    if (Array.isArray(raw)) {
      raw.forEach((entry) => {
        const pid = entry && String(entry.spuId || entry.spu_id || '')
        const handle = entry && (entry.handle || entry.spuHandle)
        if (pid && /^\d+$/.test(pid) && typeof handle === 'string' && handle) map[pid] = handle
      })
    } else if (raw && typeof raw === 'object') {
      Object.keys(raw).forEach((pid) => {
        const value = raw[pid]
        const handle = typeof value === 'string' ? value : value && (value.handle || value.spuHandle)
        if (/^\d+$/.test(pid) && typeof handle === 'string' && handle) map[pid] = handle
      })
    }
    return map
  }

  function remoteFree(remote) {
    const source = wishlistOf(remote)
    if (!source) return null
    const raw = source.freeItems !== undefined ? source.freeItems : source.free
    if (raw === undefined || raw === null || raw === '') return null
    if (typeof raw === 'boolean') return raw
    if (typeof raw === 'number') return raw > 0
    if (Array.isArray(raw)) return raw.length > 0
    return raw === '1' || raw === 'true'
  }

  function remoteCheckout(remote) {
    const source = wishlistOf(remote)
    if (!source) return ''
    const raw = source.checkoutUrl !== undefined ? source.checkoutUrl
      : source.freeCheckoutUrl !== undefined ? source.freeCheckoutUrl : source.checkout
    if (typeof raw !== 'string') return ''
    const url = raw.trim()
    return /^(https?:\/\/|\/(?!\/))/i.test(url) ? url : ''
  }

  function drawResult(payload) {
    if (!payload || typeof payload !== 'object') return null
    const draw = payload.draw && typeof payload.draw === 'object' ? payload.draw : payload
    const status = String(draw.drawStatus || draw.resultStatus || '').toUpperCase()
    if (status !== 'COMPLETED' && status !== 'REVEALED') return null
    const benefit = String(draw.benefitType || '').toUpperCase()
    const checkout = typeof draw.checkoutUrl === 'string' ? draw.checkoutUrl.trim() : ''
    const coupon = typeof draw.couponCode === 'string' ? draw.couponCode.trim() : ''
    const discount = Math.round(Number(draw.discountValue))
    return {
      free: benefit === 'FREE_ORDER',
      // 免单已使用：接口返回 freeOrderUsed === true，此时不再给跳转链接
      freeOrderUsed: draw.freeOrderUsed === true || draw.freeOrderUsed === 'true',
      coupon: benefit === 'FREE_ORDER' ? '' : coupon,
      checkout: /^(https?:\/\/|\/(?!\/))/i.test(checkout) ? checkout : '',
      discount: Number.isFinite(discount) && discount > 0 ? discount : 0,
    }
  }

  function drawOutcome(payload) {
    if (payload && payload.__uncreated) return { result: null, status: 'empty', uncreated: true }
    const result = drawResult(payload)
    if (result) return { result, status: 'completed' }
    const draw = payload && typeof payload === 'object'
      ? (payload.draw && typeof payload.draw === 'object' ? payload.draw : payload)
      : null
    const status = String((draw && (draw.drawStatus || draw.resultStatus)) || '').toUpperCase()
    if (status === 'WAITING') return { result: null, status: 'waiting' }
    if (status === 'DRAWING' || status === 'PROCESSING') return { result: null, status: 'drawing' }
    if (status === 'FAILED') return { result: null, status: 'failed' }
    return { result: null, status: '' }
  }

  function rootPath() { return window.Shopify?.routes?.root || '/' }
  function localProducts(shop) {
    if (shop.products === undefined) {
      shop.products = null
      try {
        const node = shop.querySelector('.bfw-shop__products') || document.getElementById('bfw-wishlist-data')
        if (node) shop.products = JSON.parse(node.textContent)?.products || null
      } catch (error) { shop.products = null }
    }
    return shop.products
  }

  function localProduct(shop, handle, pid) {
    const products = localProducts(shop)
    if (!products) return null
    const key = pid && products[pid] ? pid : Object.keys(products).find((id) => handle && products[id].handle === handle)
    const item = key ? products[key] : null
    if (!item) return null
    return {
      title: item.title,
      handle: item.handle,
      type: item.type,
      compare_at_price: item.compare_at_price,
      price_varies: typeof item.price_varies === 'boolean' ? item.price_varies : undefined,
      price: item.price,
      card_image: item.card_image || '',
      points: item.points || [],
      variants: Object.keys(item.variants || {}).map((id) => {
        const variant = item.variants[id]
        return {
          id: Number(id),
          title: variant.title,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          available: variant.available,
          featured_image: variant.image || '',
        }
      }),
    }
  }

  function productFor(shop, handle, pid) {
    const local = localProduct(shop, handle, pid)
    if (local) return Promise.resolve(local)
    if (!handle) return Promise.resolve(null)
    return fetch(rootPath() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('product HTTP ' + response.status); return response.json() })
      .catch(() => null)
  }

  // price_varies：数据源自带布尔值就用（Liquid 快照 /products 接口），
  // 否则看变体价格是否不止一种，兼容只带 variants 的快照。
  function priceVaries(product) {
    if (typeof product?.price_varies === 'boolean') return product.price_varies
    const prices = (product?.variants || []).map((variant) => (variant && variant.price)).filter((value) => typeof value === 'number')
    if (!prices.length) return false
    return prices.some((value) => value !== prices[0])
  }

  // 卡片价格取产品最低价（product.price / price_min，Liquid 快照的 price 也是最低价），
  // 不是选中变体的价格；数据源只剩 variants 时才取变体最低价。
  function productPrice(product, variant) {
    if (typeof product?.price === 'number') return product.price
    if (typeof product?.price_min === 'number') return product.price_min
    const prices = (product?.variants || []).map((item) => (item && item.price)).filter((value) => typeof value === 'number')
    if (prices.length) return Math.min.apply(null, prices)
    return typeof variant?.price === 'number' ? variant.price : null
  }

  function element(tag, className, value) {
    const node = document.createElement(tag)
    if (className) node.className = className
    if (value != null) node.textContent = value
    return node
  }

  let moneyLocale = ''
  let moneyCurrency = ''
  let cachedMoneyFormatter

  function moneyFormatter() {
    const locale = document.documentElement.lang || 'en'
    const currency = window.Shopify?.currency?.active || 'USD'
    if (!cachedMoneyFormatter || locale !== moneyLocale || currency !== moneyCurrency) {
      cachedMoneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' })
      moneyLocale = locale
      moneyCurrency = currency
    }
    return cachedMoneyFormatter
  }

  function currencySymbol() {
    try { return moneyFormatter().formatToParts(0).find((part) => part.type === 'currency')?.value || '$' }
    catch (error) { return '$' }
  }

  function formatMoney(cents) {
    const amount = Number(cents) / 100
    if (!Number.isFinite(amount)) return ''
    const formatter = window.T4SThemeSP?.Currency?.formatMoney
    let text = ''
    if (formatter) {
      text = String(formatter(cents))
        .replace(/[A-Z]{1,3}\$/g, '$')
        .replace(/\s*\b[A-Z]{3}\b\s*/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim()
    }
    if (!text) {
      try { text = moneyFormatter().format(amount) }
      catch (error) { text = '$' + amount.toFixed(2) }
    }
    return /[^\d\s.,]/.test(text) ? text : currencySymbol() + text
  }

  class BfwWishlistShop extends HTMLElement {
    connectedCallback() {
      try { this.config = JSON.parse(this.querySelector('.bfw-shop__config')?.textContent || '{}') }
      catch (error) { this.config = {} }
      this.views = {
        guest: this.querySelector('.bfw-shop__guest'),
        empty: this.querySelector('.bfw-shop__empty'),
        created: this.querySelector('.bfw-shop__created'),
      }
      this.cards = this.querySelector('.bfw-shop__cards')
      this.addAll = this.querySelector('.bfw-shop__add-all')
      this.checkout = this.querySelector('.bfw-shop__checkout')
      this.status = this.querySelector('.bfw-shop__status')
      this.lines = []
      this.products = undefined
      this.remoteHandles = Object.create(null)
      this.freeState = null
      this.draw = null
      this.checkoutUrl = ''
      this.previewView = window.Shopify?.designMode ? window.__bfwPreviewView__ || '' : ''
      this.fetchGeneration = 0
      this.cardGeneration = 0
      this.signature = ''
      this.inFlightSignature = ''
      this.busy = false
      this.stripStates = new WeakMap()
      this.drawInFlight = null
      this.drawCache = null
      this.wishlistCache = null
      this.wishlistInFlight = null
      this.bootTimer = 0
      this.scrollAfterLogin = false
      // 已经拿到过开奖结论的 token 与状态（drawStatus 未确定前不进 created 视图）。
      this.settledAuth = ''
      this.settledStatus = ''
      this.onLogin = () => {
        document.documentElement.classList.add('bfw-authed')
        this.clearCaches()
        this.refresh()
        if (this.scrollAfterLogin) {
          this.scrollAfterLogin = false
          this.scrollIntoSelf()
        }
      }
      this.onLogout = () => {
        this.scrollAfterLogin = false
        document.documentElement.classList.remove('bfw-authed')
        this.clearCaches()
        this.refresh()
      }
      this.onChange = () => { this.clearCaches(); this.refresh() }
      this.onStorage = (event) => {
        if (event.key === STORAGE_KEY || event.key === CREATED_KEY || event.key === null) {
          this.clearCaches()
          this.refresh()
        }
      }
      this.onStrip = (records) => {
        let changed = false
        records.forEach((record) => {
          const next = record.target.getAttribute('data-state') || ''
          if (this.stripStates.get(record.target) !== next) {
            this.stripStates.set(record.target, next)
            changed = true
          }
        })
        if (changed) this.refresh()
      }
      this.onLoginClick = () => this.openLogin()
      this.onAddAllClick = () => { this.addToCart(this.lines, this.addAll).catch(() => { }) }
      this.onBlockSelect = (event) => {
        if (!window.Shopify?.designMode) return
        const view = event.target?.closest?.('[data-bfw-view]')?.dataset.bfwView
        if (!view) return
        this.previewView = view
        this.applyPreview(view)
      }
      // UI 走查用临时面板的点击处理（?bfwdev=1 才生效，走查完连同下方 isDevMode / applyPreview 的
      // waiting|drawing|failed 分支、模板里的 .bfw-shop__dev 与 CSS 一起删除）。
      this.onDevClick = (event) => {
        const button = event.target?.closest?.('[data-bfw-dev]')
        if (!button) return
        event.preventDefault()
        const view = button.dataset.bfwDev || ''
        if (view) {
          this.previewView = view
          this.applyPreview(view)
        } else {
          // 空值 = 回到真实接口数据。
          this.previewView = ''
          this.refresh()
        }
        this.devPanel?.querySelectorAll('[data-bfw-dev]').forEach((node) => {
          node.classList.toggle('is-active', node === button)
        })
      }
      this.onCartOpen = (event) => {
        if (!this.contains(event.target)) return
        const overlay = event.detail && event.detail.overlay
        if (!overlay) return
        this.cartOverlay = overlay
        this.cartConfirm = () => this.confirmQuickShop(overlay)
        overlay._dsmOnConfirm = this.cartConfirm
      }
      this.querySelector('.bfw-shop__login')?.addEventListener('click', this.onLoginClick)
      // UI 走查用临时面板：地址栏带 ?bfwdev=1 才显示（走查完整块删除）。
      this.devPanel = this.querySelector('.bfw-shop__dev')
      if (this.devPanel) {
        this.devPanel.hidden = !this.isDevMode()
        this.devPanel.addEventListener('click', this.onDevClick)
      }
      this.addAll?.addEventListener('click', this.onAddAllClick)
      document.addEventListener('qs:cart-open', this.onCartOpen)
      document.addEventListener('shopify:block:select', this.onBlockSelect)
      document.addEventListener('LUTE:AUTH:LOGIN', this.onLogin)
      document.addEventListener('LUTE:AUTH:LOGOUT', this.onLogout)
      document.addEventListener('bfw:wishlist:change', this.onChange)
      window.addEventListener('storage', this.onStorage)
      this.stripObserver = new MutationObserver(this.onStrip)
      document.querySelectorAll('bfw-strip').forEach((strip) => {
        this.stripStates.set(strip, strip.getAttribute('data-state') || '')
        this.stripObserver.observe(strip, { attributes: true, attributeFilter: ['data-state'] })
      })
      // 已登录用户首屏由 momcozy-login 的 LUTE:AUTH:LOGIN（detail.type === 'keep'）触发 onLogin 去拉数据，
      // 这里不再重复 refresh：auth 已完成（body 上有 momcozy-logined）时事件已错过，直接拉；
      // 否则等 onLogin，只留一个兜底定时器防事件没派发。无 token 不发请求，直接切 guest 视图。
      if (token()) {
        // drawStatus 未确定前先骨架占位（不看本地快照），否则有本地清单的已开奖用户会先看到列表再跳到等待态。
        if (!this.previewView) this.showSkeleton()
        if (document.body.classList.contains('momcozy-logined')) this.refresh()
        else this.bootTimer = window.setTimeout(() => { this.bootTimer = 0; this.refresh() }, 2500)
      } else {
        this.refresh()
      }
    }

    disconnectedCallback() {
      if (this.bootTimer) { window.clearTimeout(this.bootTimer); this.bootTimer = 0 }
      this.fetchGeneration++
      this.cardGeneration++
      this.stripObserver?.disconnect()
      this.querySelector('.bfw-shop__login')?.removeEventListener('click', this.onLoginClick)
      this.devPanel?.removeEventListener('click', this.onDevClick)
      this.devPanel = null
      this.addAll?.removeEventListener('click', this.onAddAllClick)
      document.removeEventListener('qs:cart-open', this.onCartOpen)
      document.removeEventListener('shopify:block:select', this.onBlockSelect)
      document.removeEventListener('LUTE:AUTH:LOGIN', this.onLogin)
      document.removeEventListener('LUTE:AUTH:LOGOUT', this.onLogout)
      document.removeEventListener('bfw:wishlist:change', this.onChange)
      window.removeEventListener('storage', this.onStorage)
      if (this.cartOverlay?._dsmOnConfirm === this.cartConfirm) delete this.cartOverlay._dsmOnConfirm
      this.cartOverlay = null
      this.cartConfirm = null
    }

    setView(name) {
      this.classList.remove('bfw-shop--pending')
      Object.entries(this.views).forEach(([key, view]) => { if (view) view.hidden = key !== name })
      const current = this.views[name]
      if (current) current.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager'
        img.fetchPriority = 'high'
      })
    }

    setEmptyCopy(name) {
      const current = name == null ? 'empty' : name
      this.querySelectorAll('[data-bfw-empty-copy]').forEach((node) => {
        node.hidden = node.dataset.bfwEmptyCopy !== current
      })
    }

    emptyFor(status) {
      const copy = status === 'waiting' || status === 'drawing' || status === 'failed' ? status : 'empty'
      this.classList.remove('bfw-shop--pending')
      this.setEmptyCopy(copy)
      this.setView('empty')
    }

    notice(message) { if (this.status) this.status.textContent = message || '' }

    resetList() {
      ++this.cardGeneration
      this.signature = ''
      this.inFlightSignature = ''
      this.lines = []
      this.cards.replaceChildren()
      this.addAll.disabled = true
    }

    hasLocalList() {
      const state = localState()
      return !!state.created && Object.keys(state.items).length > 0
    }

    // 加载中借「开奖中」文案做占位（信封图 + Unlocking Your Discount Surprise...），
    // 避免出现「只有背景图没文案」的空白态，也不先闪一下「未创建清单」。
    showSkeleton() {
      this.resetList()
      this.setEmptyCopy('drawing')
      this.setView('empty')
      this.classList.add('bfw-shop--pending')
    }

    isFree() {
      if (this.draw) return this.draw.free
      return this.freeState === true
    }

    couponCode() {
      return this.draw ? this.draw.coupon : ''
    }

    // 加购后把 draw 的折扣码同步到购物车：优先复用主题的 applyDiscountCode（Storefront API，能进 checkout），
    // 兜底走 /discount/<code> 写 cookie。全程不 reject，避免折扣同步失败被上层当成“加购失败”报错。
    applyCoupon() {
      const code = this.couponCode()
      if (!code) return Promise.resolve()
      // 只有 Storefront SDK 可用时才走 applyDiscountCode：它内部拿不到 updateCart 会静默降级到
      // cart/update.js（进不了 checkout），那种情况不如直接用下面的 /discount/ cookie 兜底。
      const theme = window.T4SThemeSP && window.T4SThemeSP.Cart
      const sdk = window.Shopify && window.Shopify.actions
      const canSync = theme && typeof theme.applyDiscountCode === 'function' && sdk && typeof sdk.updateCart === 'function'
      if (canSync) {
        try {
          return Promise.resolve(theme.applyDiscountCode(code)).catch(() => { })
        } catch (error) { /* 落到下面的兜底 */ }
      }
      // 兜底：走 Shopify 的 /discount/<code> 端点。它会写入 discount_code cookie，
      // checkout 才能继承；cart/update.js 的 discount 参数只在 cart 展示层生效，进不了 checkout。
      return fetch(rootPath() + 'discount/' + encodeURIComponent(code), {
        credentials: 'same-origin', redirect: 'manual',
      })
        .then(() => { })
        .catch(() => { })
    }

    badgeText() {
      if (!this.draw || !this.draw.discount) return ''
      const template = String(this.config.discountOff || '')
      if (!/\{\{\s*value\s*\}\}/.test(template)) return ''
      return template.replace(/\{\{\s*value\s*\}\}/g, String(this.draw.discount))
    }

    freeMode() {
      return !!this.querySelector('.bfw-shop__free-banner') && this.isFree()
    }

    syncCheckout(free) {
      if (!this.addAll) return
      // 免单已使用（draw 的 freeOrderUsed === true）时不给跳转链接，购物车 CTA 也一并隐藏：
      // 这时既没有可用的免单结算链接，也不需要再“全加购”。
      const used = !!(this.draw && this.draw.freeOrderUsed)
      const usable = free && !used
      const url = usable ? this.checkoutUrl : ''
      if (this.checkout) {
        if (url) this.checkout.setAttribute('href', url)
        else this.checkout.removeAttribute('href')
        this.checkout.hidden = !url
      }
      this.addAll.hidden = !!url || used
    }

    // UI 走查用：地址栏 ?bfwdev=1 时当作预览模式，直接走 applyPreview，不请求接口。
    isDevMode() {
      try { return new URLSearchParams(window.location.search).get('bfwdev') === '1' } catch (error) { return false }
    }

    isPreviewMode() {
      return !!window.Shopify?.designMode || this.isDevMode()
    }

    demoData(count) {
      const products = localProducts(this) || {}
      const data = Object.create(null)
      Object.keys(products).slice(0, count).forEach((pid) => {
        const item = products[pid] || {}
        const variants = item.variants || {}
        const ids = Object.keys(variants)
        const id = ids.find((key) => variants[key]?.available) || ids[0]
        if (!id) return
        data[pid] = [{ uid: String(id), qty: 1, handle: typeof item.handle === 'string' ? item.handle : '' }]
      })
      return data
    }

    applyPreview(view) {
      window.__bfwPreviewView__ = view
      // 走查预览：guest 必须去掉 html.bfw-authed，否则 CSS 会把 .bfw-shop__guest 整块 display:none；
      // 其余预览态（empty / waiting / drawing / failed / created*）都按已登录演示。
      if (view === 'guest') document.documentElement.classList.remove('bfw-authed')
      else document.documentElement.classList.add('bfw-authed')
      this.fetchGeneration++
      this.resetList()
      this.notice('')
      this.freeState = view === 'created_free' || view === 'created_free_three' ? true : view === 'created' || view === 'created_three' ? false : null
      // UI 走查用：created / created_three 造一条折扣结果，让卡片带上的折扣条与优惠码区，
      // 走查完可改这里或整段删除。（created_free / created_free_three 仍为 null，免单态不渲染折扣条。）
      this.draw = view === 'created' || view === 'created_three'
        ? { free: false, coupon: 'BFW20DEMO', checkout: '', discount: 20 }
        : null
      this.checkoutUrl = ''
      this.classList.remove('bfw-shop--free', 'bfw-shop--items-3')
      this.syncCheckout(false)
      if (view === 'waiting' || view === 'drawing' || view === 'failed') {
        // UI 走查用：直接复用 state_empty 的四份文案（waiting / drawing / failed）。
        this.emptyFor(view)
        if (view === 'drawing') this.classList.add('bfw-shop--pending')
        return
      }
      if (view === 'guest' || view === 'empty') {
        this.setEmptyCopy('empty')
        this.setView(view)
        return
      }
      const data = this.demoData(view === 'created_three' || view === 'created_free_three' ? 3 : 4)
      if (!Object.keys(data).length) {
        this.setView('empty')
        return
      }
      this.render(data)
    }

    openLogin() {
      // 只标记「这次登录由本模块发起」，登录成功的 LUTE:AUTH:LOGIN 才回跳本模块；
      // 页面加载时 auth keep 派发的同一事件不会触发回跳。
      this.scrollAfterLogin = true
      const target = this.anchorUrl()
      const dialog = document.querySelector('login-dialog')
      if (dialog && typeof dialog.open === 'function') {
        // redirect 带锚点：第三方登录（Apple / Facebook 等）整页回跳时浏览器直接落到本模块。
        dialog.open(null, { activityType: this.config.loginSource, redirect: target })
        return
      }
      const loginUrl = this.config.loginUrl || '/account/login'
      window.location.href = loginUrl
        + (loginUrl.indexOf('?') > -1 ? '&' : '?')
        + 'return_url=' + encodeURIComponent(target)
    }

    anchorUrl() {
      const base = window.location.href.split('#')[0]
      return this.id ? base + '#' + this.id : base
    }

    scrollIntoSelf() {
      if (this.isPreviewMode()) return
      if (!this.getBoundingClientRect().height) return
      // 同页登录不刷新页面，锚点不会自动滚动，所以先把锚点写进地址栏（replaceState 不增历史记录、
      // 也不触发滚动），再自己滚一下；`.bfw-shop` 的 scroll-margin-top 会避开粘性头部。
      const hash = '#' + this.id
      if (this.id && window.location.hash !== hash) {
        try { window.history.replaceState(null, '', hash) } catch (error) { }
      }
      const run = () => this.scrollIntoView({ behavior: 'smooth', block: 'start' })
      window.requestAnimationFrame(() => window.requestAnimationFrame(run))
    }

    apiGet(path, auth) {
      const config = window.__MC__CONFIG__ || {}
      if (!auth || !config.apiUrl) return Promise.resolve(undefined)
      const headers = Object.assign({ 'Content-Type': 'application/json' }, config.headers || {})
      headers.Authorization = 'Bearer ' + auth
      const controller = window.AbortController ? new AbortController() : null
      const timer = controller ? setTimeout(() => controller.abort(), 15000) : 0
      const base = String(config.apiUrl).replace(/\/+$/, '') + '/api/station/activity/wishlist/' + encodeURIComponent(this.config.activityCode || 'WISHLIST_2026')
      return fetch(base + path, { headers, credentials: 'omit', signal: controller?.signal })
        .then((response) => { if (!response.ok) throw new Error('wishlist HTTP ' + response.status); return response.json() })
        .then((payload) => {
          if (payload && payload.code != null && String(payload.code) !== '200') {
            if (UNCREATED_CODES.indexOf(String(payload.code)) >= 0) return { __uncreated: true }
            throw new Error('wishlist API ' + payload.code)
          }
          return payload && (payload.result !== undefined ? payload.result : payload.data !== undefined ? payload.data : payload)
        })
        .finally(() => { if (timer) clearTimeout(timer) })
    }

    fetchWishlist(auth) { return this.apiGet('', auth) }

    fetchDraw(auth) { return this.apiGet('/draw', auth) }

    clearCaches() { this.drawCache = null; this.wishlistCache = null }

    cachedFetch(slot, fetcher, auth) {
      const state = this[slot]
      if (state && state.auth === auth && Date.now() - state.at < API_CACHE_TTL) {
        return Promise.resolve(state.payload)
      }
      return fetcher(auth).then((payload) => {
        this[slot] = { auth, payload, at: Date.now() }
        return payload
      })
    }

    wishlistPayload(auth) {
      if (this.wishlistInFlight && this.wishlistInFlight.auth === auth) return this.wishlistInFlight.promise
      const promise = this.cachedFetch('wishlistCache', (tokenValue) => this.fetchWishlist(tokenValue), auth)
      const entry = { auth, promise }
      const clear = () => { if (this.wishlistInFlight === entry) this.wishlistInFlight = null }
      this.wishlistInFlight = entry
      promise.then(clear, clear)
      return promise
    }

    drawPayload(auth) {
      if (this.drawInFlight && this.drawInFlight.auth === auth) return this.drawInFlight.promise
      const promise = this.cachedFetch('drawCache', (tokenValue) => this.fetchDraw(tokenValue), auth)
      const entry = { auth, promise }
      const clear = () => { if (this.drawInFlight === entry) this.drawInFlight = null }
      this.drawInFlight = entry
      promise.then(clear, clear)
      return promise
    }

    productCard(entries, product, handle) {
      const item = element('li', 'bfw-shop__card')
      const free = this.classList.contains('bfw-shop--free')
      const variants = product?.variants || []
      const selected = entries.map((entry) => ({
        id: entry.uid, quantity: entry.qty,
        variant: variants.find((variant) => String(variant.id) === entry.uid),
      }))
      const purchasable = selected.filter((entry) => entry.variant?.available)
      const first = selected[0]?.variant
      const price = productPrice(product, first)
      const compare = product?.compare_at_price ?? first?.compare_at_price
      const link = rootPath() + 'products/' + encodeURIComponent(handle)
      const media = element('a', 'bfw-shop__media')
      if (handle) media.href = link
      else media.setAttribute('aria-disabled', 'true')
      const imageSrc = product?.card_image || first?.featured_image?.src || first?.featured_image || product?.featured_image || product?.images?.[0]
      if (typeof imageSrc === 'string' && (/^https?:\/\//.test(imageSrc) || /^\/\//.test(imageSrc) || /^\/(?!\/)/.test(imageSrc))) {
        const image = document.createElement('img')
        image.src = imageSrc
        image.alt = product?.title || ''
        image.loading = 'lazy'
        image.width = 300
        image.height = 280
        media.appendChild(image)
      }
      item.appendChild(media)
      const body = element('div', 'bfw-shop__body')
      const badge = this.badgeText()
      if (badge && !free) {
        const discount = element('p', 'bfw-shop__discount', badge)
        const gift = element('span', 'bfw-shop__gift')
        gift.setAttribute('aria-hidden', 'true')
        discount.appendChild(gift)
        body.appendChild(discount)
      }
      const name = element('h3', 'bfw-shop__name')
      const nameText = product?.title || this.config.unavailable
      if (handle) {
        const nameLink = element('a', '', nameText)
        nameLink.href = link
        name.appendChild(nameLink)
      } else {
        name.textContent = nameText
      }
      body.appendChild(name)
      const tags = Array.isArray(product?.points) ? product.points.filter(Boolean) : []
      if (!tags.length) {
        if (product?.type) tags.push(product.type)
        const extra = (product?.tags || []).find((tag) => typeof tag === 'string' && tag && tag !== product.type)
        if (extra) tags.push(extra)
      }
      if (tags.length) {
        const row = element('p', 'bfw-shop__tags')
        tags.slice(0, 2).forEach((tag, index) => {
          if (index) row.appendChild(element('span', 'bfw-shop__tags-sep'))
          row.appendChild(element('span', '', tag))
        })
        body.appendChild(row)
      }
      const prices = element('p', 'bfw-shop__price')
      if (price != null) {
        // 划线价：有 compare 且非免单态。
        const hasCompare = !free && compare > price
        // "From" 只看商品价格是否有区间（priceVaries()），与划线价无关；文案复用主题的
        // promo.price.from_price_html（形如 `<span class="from">From</span> {{ price }}`），
        // 不硬编码、不新增翻译 key。
        const showFrom = priceVaries(product)
        const template = String(this.config.fromPriceHtml || '')
        if (showFrom && template.includes('__BFW_PRICE__')) {
          prices.innerHTML = template.replace('__BFW_PRICE__', '<strong class="bfw-shop__amount">' + formatMoney(price) + '</strong>')
        } else {
          prices.appendChild(element('strong', 'bfw-shop__amount', formatMoney(price)))
        }
        if (hasCompare) prices.appendChild(element('del', 'bfw-shop__compare', formatMoney(compare)))
      }
      body.appendChild(prices)
      if (free) {
        const freeBadge = element('span', 'bfw-shop__free-badge')
        freeBadge.setAttribute('aria-hidden', 'true')
        item.appendChild(freeBadge)
      } else {
        const actions = element('div', 'bfw-shop__actions')
        const shop = element('a', 'bfw-shop__shop', this.config.shopLabel)
        if (handle) shop.href = link + '?variant=' + encodeURIComponent(first?.id || selected[0].id)
        else shop.setAttribute('aria-disabled', 'true')
        actions.appendChild(shop)
        const add = element('button', 'bfw-shop__add', purchasable.length ? this.config.addLabel : this.config.soldOut)
        add.type = 'button'
        add.disabled = !purchasable.length
        if (purchasable.length && handle) {
          const trigger = document.createElement('qs-modal-trigger')
          trigger.className = 'bfw-shop__qs'
          trigger.setAttribute('section-id', 'bfw-quickshop-modal')
          trigger.setAttribute('modal-id', 'bfw-quickshop-modal')
          trigger.setAttribute('content-sel', '[data-qs-slot]')
          trigger.setAttribute('mode', 'cart')
          trigger.setAttribute('confirm-label', this.config.addLabel)
          trigger.setAttribute('src', link + '?variant=' + encodeURIComponent(purchasable[0].id))
          trigger.appendChild(add)
          actions.appendChild(trigger)
        } else {
          actions.appendChild(add)
        }
        body.appendChild(actions)
        const code = this.couponCode()
        if (code) {
          const coupon = element('div', 'bfw-shop__coupon')
          coupon.appendChild(element('span', 'bfw-shop__code', code))
          const copy = document.createElement('copy-button-timeout')
          copy.className = 'bfw-shop__copy'
          copy.setAttribute('data-content', code)
          copy.setAttribute('role', 'button')
          copy.setAttribute('tabindex', '0')
          copy.setAttribute('aria-label', this.config.copyLabel + ' ' + code)
          copy.appendChild(element('span', 'copy-txt', this.config.copyLabel))
          copy.appendChild(element('span', 'copy-result', this.config.copySuccess))
          copy.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return
            event.preventDefault()
            copy.click()
          })
          coupon.appendChild(copy)
          body.appendChild(coupon)
        }
      }
      item.appendChild(body)
      return { node: item, lines: purchasable.map((entry) => ({ id: entry.id, quantity: entry.quantity })) }
    }

    confirmQuickShop(overlay) {
      const picker = overlay.querySelector('[data-qs-cart]')
      if (!picker || typeof picker.collect !== 'function') return Promise.reject(new Error(this.config.addError))
      const detail = picker.collect()
      if (!detail.variantId || detail.available === false) return Promise.reject(new Error(this.config.addError))
      return this.addToCart([{ id: detail.variantId, quantity: detail.qty || 1 }], null)
    }

    addToCart(lines, button) {
      if (!lines.length || this.busy) return Promise.reject(new Error(this.config.addError))
      this.busy = true
      if (button) {
        button.disabled = true
        button.classList.add('is-loading')
        button.setAttribute('aria-busy', 'true')
      }
      this.notice('')
      return fetch(rootPath() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines }),
      }).then((response) => {
        if (!response.ok) return response.json().catch(() => ({}))
          .then((payload) => { throw new Error(payload.description || this.config.addError) })
        return response.json()
      }).then(() => this.applyCoupon()).then(() => {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'bfw-shop' } }))
        if (window.jQuery) window.jQuery(document).trigger('cart:updated')
        this.openCart()
      }).catch((error) => {
        this.notice(error.message || this.config.addError)
        throw error
      }).finally(() => {
        this.busy = false
        if (!button) return
        button.classList.remove('is-loading')
        button.removeAttribute('aria-busy')
        button.disabled = button === this.addAll ? !this.lines.length : false
      })
    }

    openCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh:opend', { bubbles: true }))
    }

    render(data) {
      const groups = Object.keys(data).slice(0, 4)
      if (!groups.length) {
        this.resetList()
        this.classList.remove('bfw-shop--items-3', 'bfw-shop--free')
        this.syncCheckout(false)
        this.setEmptyCopy('empty')
        this.setView('empty')
        return
      }
      const free = this.freeMode()
      this.classList.toggle('bfw-shop--free', free)
      this.syncCheckout(free)
      this.classList.toggle('bfw-shop--items-3', groups.length === 3)
      const plan = groups.map((pid) => {
        const entries = data[pid]
        const fromEntry = entries.find((entry) => entry.handle)
        const handle = fromEntry?.handle || this.remoteHandles[pid] || localProducts(this)?.[pid]?.handle || ''
        return { pid, entries, handle: typeof handle === 'string' ? handle : '' }
      })
      const signature = (free ? 'free:' : 'regular:') + this.couponCode() + '|' + this.badgeText() + '|'
        + plan.map((item) => item.pid + ':' + item.handle + ':' + item.entries.map((entry) => entry.uid + 'x' + entry.qty).join(',')).join('|')
      if (this.views.created && !this.views.created.hidden
        && (signature === this.signature || signature === this.inFlightSignature)) return
      this.inFlightSignature = signature
      this.cards.replaceChildren()
      this.lines = []
      this.addAll.disabled = true
      this.setView('created')
      const generation = ++this.cardGeneration
      Promise.all(plan.map((item) => productFor(this, item.handle, item.pid)
        .then((product) => this.productCard(item.entries, product, item.handle)))).then((results) => {
          if (!this.isConnected || generation !== this.cardGeneration) return
          results.forEach((result) => {
            this.cards.appendChild(result.node)
            this.lines.push(...result.lines)
          })
          this.signature = signature
          this.inFlightSignature = ''
          this.addAll.disabled = !this.lines.length
        }).catch(() => {
          if (generation === this.cardGeneration) {
            this.inFlightSignature = ''
            this.addAll.disabled = true
            this.notice(this.config.addError)
          }
        })
    }

    refresh() {
      if (this.isPreviewMode() && this.previewView) {
        this.applyPreview(this.previewView)
        return
      }
      if (this.bootTimer) { window.clearTimeout(this.bootTimer); this.bootTimer = 0 }
      const generation = ++this.fetchGeneration
      // 登录态只看 cookie token（Luteos 登录），不看 Liquid 的 customer，也不缓存成字段。
      const auth = token()
      // html.bfw-authed 与 token 保持一致（走查面板切到 guest 后点“真实”时要把类补回来）。
      if (auth) document.documentElement.classList.add('bfw-authed')
      else document.documentElement.classList.remove('bfw-authed')
      if (!auth) {
        this.resetList()
        this.notice('')
        this.settledAuth = ''
        this.settledStatus = ''
        this.classList.remove('bfw-shop--free', 'bfw-shop--items-3')
        this.freeState = null
        this.draw = null
        this.remoteHandles = Object.create(null)
        this.checkoutUrl = ''
        this.syncCheckout(false)
        this.setView('guest')
        return
      }
      const state = localState()
      const local = state.items
      const hasLocal = state.created && Object.keys(local).length > 0
      // drawStatus 未确定前不进 created：先骨架占位，否则有本地清单的已开奖用户会先渲染清单再跳到等待态。
      // 只有同一个 token 已经拿到过 COMPLETED 结论（之后的清单增删等 refresh）才用本地快照做乐观渲染，
      // 其他状态保持当前视图，等新结果回来再切。
      if (this.settledAuth !== auth) this.showSkeleton()
      else if (this.settledStatus === 'completed' && hasLocal) this.render(local)
      Promise.all([
        this.wishlistPayload(auth).then((remote) => ({ remote })).catch(() => ({ remote: undefined })),
        this.drawPayload(auth).then((payload) => drawOutcome(payload)).catch(() => ({ result: null, status: 'failed', requestFailed: true })),
      ]).then(([wishlist, drawn]) => {
        if (!this.isConnected || generation !== this.fetchGeneration || token() !== auth) return
        this.draw = drawn.result
        this.settledAuth = auth
        this.settledStatus = drawn.status
        // drawStatus 优先级高于清单：WAITING / DRAWING / FAILED 期间，即使服务端已有清单商品，
        // 界面也只展示 state_empty 对应文案（这是这个区块的主信息）。draw 请求本身报错（没有
        // drawStatus）不算状态，不因此隐藏用户已有的清单。
        if (drawn.status === 'waiting' || drawn.status === 'drawing'
          || (drawn.status === 'failed' && !drawn.requestFailed)) {
          this.resetList()
          this.classList.remove('bfw-shop--free', 'bfw-shop--items-3')
          this.freeState = null
          this.remoteHandles = Object.create(null)
          this.checkoutUrl = ''
          this.syncCheckout(false)
          this.emptyFor(drawn.status)
          return
        }
        const remote = wishlist.remote
        if (remote === undefined) {
          // detail 请求失败：本地有快照就用本地，没有则按 draw 状态占位。
          if (hasLocal) this.render(local)
          else this.emptyFor(drawn.status)
          return
        }
        const server = remoteItems(remote)
        const freed = remoteFree(remote)
        this.freeState = freed
        this.checkoutUrl = (this.draw && this.draw.checkout) || remoteCheckout(remote)
        const freeNow = this.freeMode()
        this.classList.toggle('bfw-shop--free', freeNow)
        this.syncCheckout(freeNow)
        this.remoteHandles = remoteHandles(remote)
        if (!Object.keys(server).length) {
          if (hasLocal) this.render(local)
          else this.emptyFor(drawn.status)
          return
        }
        Object.keys(server).forEach((pid) => {
          server[pid].forEach((entry) => {
            const old = (local[pid] || []).find((item) => item.uid === entry.uid)
            if (old?.handle) entry.handle = old.handle
          })
        })
        this.render(server)
      }).catch(() => {
        if (this.isConnected && generation === this.fetchGeneration && token() === auth && !hasLocal) this.render({})
      })
    }
  }

  if (!customElements.get('bfw-wishlist-shop')) customElements.define('bfw-wishlist-shop', BfwWishlistShop)
})()
